import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchSpendDownloadMenuConfig, saveSpendDownloadMenuConfig } from "actions/userActions";

const FIXED_ROLES = { 1: "Admin", 2: "Standard Internal User", 3: "Delivery Internal User", 4: "Standard Partner User", 5: "Delivery Partner User", 6: "Standard Customer User" };

class AdminSpendDownloadMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      originalData: null,
      configData: [],
      solutionScope: "SCC",
      valueStorySelection: "Sales",
      responseMsg: "",
      isError: false,
      isLoading: false
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    this.setState({ isLoading: true });

    this.props.fetchSpendDownloadMenuConfig()
      .then((res) => {
        if (!res || !res.data) {
          this.setState({ isError: true, isLoading: false });
          return;
        }

        this.setState({
          originalData: res.data,
          configData: this.applySelection(res.data),
          isLoading: false
        });
      })
      .catch(() => this.setState({ isError: true, isLoading: false }));
  }

  applySelection(data) {
    const result = [];
    if (!data || !data.Menus || !data.Groups || !data.Roles) return [];

    const scopeKey = this.state.solutionScope.toLowerCase();
    const filterValueStory = this.state.valueStorySelection;

    for (let g = 0; g < data.Groups.length; g++) {
      const group = data.Groups[g];
      const groupMenus = [];

      for (let m = 0; m < data.Menus.length; m++) {
        const menu = data.Menus[m];

        if (menu.GroupId !== group.GroupId) continue;

        // // ------- ValueStory Filter ---------
        // if (
        //   menu.ValueStoryTypes &&
        //   menu.ValueStoryTypes.indexOf(filterValueStory) === -1 &&
        //   filterValueStory !== "Both"
        // ) {
        //   continue;
        // }

        const matrix = {};

        for (let r = 0; r < data.Roles.length; r++) {
          const role = data.Roles[r];
          let sccAllowed = false;
          let nonSCCAllowed = false;

          if (menu.Access && menu.Access.length > 0) {
            for (let a = 0; a < menu.Access.length; a++) {
              const acc = menu.Access[a];
              if (acc.RoleId === role.RoleId) {
                sccAllowed = acc.IsSCCAllowed === true;
                nonSCCAllowed = acc.IsNonSCCAllowed === true;
                break;
              }
            }
          }

          matrix[role.RoleName] = {
            scc: sccAllowed,
            nonSCC: nonSCCAllowed
          };

        }

        groupMenus.push({
          MenuId: menu.MenuId,
          value: menu.Value,
          label: menu.Label,
          visibleMatrix: matrix,
          valueStoryTypes: menu.ValueStoryTypes.slice()
        });
      }

      result.push({
        group: group.GroupName,
        groupId: group.GroupId,
        items: groupMenus
      });
    }

    return result;
  }

  toggleRoleAccess(gIndex, iIndex, role) {
    const copy = JSON.parse(JSON.stringify(this.state.configData));
    const scope = this.state.solutionScope.toLowerCase();

    // Normalize initial structure (boolean → SCC structure)
    const current = copy[gIndex].items[iIndex].visibleMatrix[role];

    if (typeof current === "boolean") {
      // Convert boolean → structured access
      copy[gIndex].items[iIndex].visibleMatrix[role] = {
        scc: current,
        nonSCC: current
      };
    }

    const access = copy[gIndex].items[iIndex].visibleMatrix[role];
    let changed = false;

    if (scope === "scc") {
      access.scc = !access.scc;
      changed = true;
    }
    else if (scope === "nonscc") {
      access.nonSCC = !access.nonSCC;
      changed = true;
    }

    if (changed) copy[gIndex].items[iIndex]._isChanged = true;

    this.setState({ configData: copy });
  }


  toggleValueStory(gIndex, iIndex, key) {
    const config = JSON.parse(JSON.stringify(this.state.configData));
    const list = config[gIndex].items[iIndex].valueStoryTypes;

    const pos = list.indexOf(key);
    if (pos > -1) list.splice(pos, 1);
    else list.push(key);

    // Mark this row as changed
    config[gIndex].items[iIndex]._isChanged = true;

    this.setState({ configData: config });
  }

  handleDropdownChange = (field, value) => {

    const nextSolutionScope =
      field === "solutionScope" ? value : this.state.solutionScope;

    const nextValueStorySelection =
      field === "valueStorySelection" ? value : this.state.valueStorySelection;

    this.setState({ [field]: value }, () => {

      if (!this.state || !this.state.originalData) return;

      const refreshed = this.applySelectionWithFilters(
        this.state.originalData,
        nextSolutionScope,
        nextValueStorySelection
      );

      // 🔥 Merge unsaved changes
      const configData = this.state ? this.state.configData : null;
      if (configData && Array.isArray(refreshed)) {
        for (let g = 0; g < refreshed.length; g++) {

          const refreshedGroup = refreshed[g];
          const existingGroup = configData[g];

          if (!refreshedGroup || !refreshedGroup.items) continue;

          for (let i = 0; i < refreshedGroup.items.length; i++) {

            if (!existingGroup || !existingGroup.items) continue;

            const existingItem = existingGroup.items[i];
            const refreshedItem = refreshedGroup.items[i];

            if (!existingItem || !refreshedItem) continue;

            refreshedItem.visibleMatrix = existingItem.visibleMatrix;
            refreshedItem.valueStoryTypes = existingItem.valueStoryTypes;
            refreshedItem._isChanged = existingItem._isChanged;
          }
        }
      }

      this.setState({ configData: refreshed });
    });
  };


  // same logic as applySelection but accepts filter values explicitly
  applySelectionWithFilters(data, solutionScopeValue, valueStoryFilter) {
    const result = [];
    if (!data || !data.Menus || !data.Groups || !data.Roles) return [];

    const scopeKey = (solutionScopeValue || "SCC").toLowerCase();
    const filterValueStory = valueStoryFilter || "Sales";

    for (let g = 0; g < data.Groups.length; g++) {
      const group = data.Groups[g];
      const groupMenus = [];

      for (let m = 0; m < data.Menus.length; m++) {
        const menu = data.Menus[m];
        if (menu.GroupId !== group.GroupId) continue;

        // // ValueStory filter
        // if (
        //   menu.ValueStoryTypes &&
        //   menu.ValueStoryTypes.indexOf(filterValueStory) === -1 &&
        //   filterValueStory !== "Both"
        // ) {
        //   continue;
        // }

        // build normalized visibleMatrix object { scc, nonSCC } for each role
        const matrix = {};
        for (let r = 0; r < data.Roles.length; r++) {
          const role = data.Roles[r];
          let sccAllowed = false;
          let nonSCCAllowed = false;

          if (menu.Access && menu.Access.length > 0) {
            for (let a = 0; a < menu.Access.length; a++) {
              const acc = menu.Access[a];
              if (acc.RoleId === role.RoleId) {
                sccAllowed = acc.IsSCCAllowed === true;
                nonSCCAllowed = acc.IsNonSCCAllowed === true;
                break;
              }
            }
          }

          matrix[role.RoleName] = { scc: sccAllowed, nonSCC: nonSCCAllowed };
        }

        groupMenus.push({
          MenuId: menu.MenuId,
          value: menu.Value,
          label: menu.Label,
          visibleMatrix: matrix,
          valueStoryTypes: menu.ValueStoryTypes ? menu.ValueStoryTypes.slice() : []
        });
      }

      result.push({
        group: group.GroupName,
        groupId: group.GroupId,
        items: groupMenus
      });
    }

    return result;
  }



  handleSave = () => {
    const entries = [];
    const menuValueStories = [];

    for (let g = 0; g < this.state.configData.length; g++) {
      const group = this.state.configData[g];

      for (let i = 0; i < group.items.length; i++) {
        const item = group.items[i];

        // Only include rows that have been changed
        if (!item._isChanged) continue;

        // Build role access entries
        Object.entries(FIXED_ROLES).forEach(([roleId, roleName]) => {
          entries.push({
            RoleId: parseInt(roleId),
            MenuId: item.MenuId,
            IsSCCAllowed: item.visibleMatrix[roleName].scc,
            IsNonSCCAllowed: item.visibleMatrix[roleName].nonSCC // adjust if you have separate SCC/nonSCC
          });
        });

        // Add ValueStoryTypes
        if (item.valueStoryTypes && item.valueStoryTypes.length > 0) {
          item.valueStoryTypes.forEach(vtName => {
            menuValueStories.push({
              MenuId: item.MenuId,
              ValueStoryTypeName: vtName
            });
          });
        }
        else if (item.valueStoryTypes && item.valueStoryTypes.length == 0) {
          menuValueStories.push({
            MenuId: item.MenuId,
            ValueStoryTypeName: 'Delete'
          });
        }
      }
    }

    const payload = { entries, menuValueStories, Email : this.props.user.user.Email };
    this.props.saveSpendDownloadMenuConfig(payload);
    this.props.fetchSpendDownloadMenuConfig()
      .then(() => this.resetChangeFlags());
    this.setState({ responseMsg: "Saved!", isError: false });
  };

  resetChangeFlags = () => {
    const updated = [...this.state.configData];

    for (let g = 0; g < updated.length; g++) {
      for (let i = 0; i < updated[g].items.length; i++) {
        updated[g].items[i]._isChanged = false;
      }
    }

    this.setState({ configData: updated });
  };



  render() {
    return (
      <div>
        <h2>Spend Download Menu Access</h2>

        <div className="grid-x" style={{ width: "100%", marginBottom: "15px" }}>

          <div className="medium-3 float-left" style={{ fontSize: "1.2rem", paddingBottom: "8px" }}>
            Spend Download Menu Access
          </div>

          <div className="medium-6" style={{ display: "flex", justifyContent: "center" }}>
            {this.state.isError
              ? <div style={{ margin: "0 0 0.5rem", color: "red" }}>{this.state.responseMsg}</div>
              : <div style={{ margin: "0 0 0.5rem", color: "#4fb81c" }}>{this.state.responseMsg}</div>}
          </div>

          <div className="medium-3"></div>

          <div className="grid-x" style={{ width: "100%", marginTop: "10px" }}>
            <div className="medium-11 float-left">
              <table style={{ border: "solid 1px #ccc" }}>
                <tbody>
                  <tr>
                    <td style={{ padding: "5px 10px" }}>Solution in Scope:</td>
                    <td style={{ padding: "5px 10px" }}>
                      <select
                        style={{ height: "32px", width: "220px" }}
                        value={this.state.solutionScope}
                        onChange={(e) => this.handleDropdownChange("solutionScope", e.target.value)}
                      >
                        <option value="SCC">Supply Chain Collaboration</option>
                        <option value="NonSCC">Default</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="medium-1" style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                className="hand-cursor"
                style={{
                  background: "transparent",
                  border: "none",
                  marginTop: "5px",
                  opacity: this.state.configData.some(x => x.items.some(y => y._isChanged)) ? 1 : 0.4
                }}
                disabled={!this.state.configData.some(x => x.items.some(y => y._isChanged))}
                onClick={this.handleSave}
              >
                <img width="28" title="Save" src="images/save_active.svg" alt="save" />
              </button>
            </div>
          </div>
        </div>


        <table className="basic-table">
          <thead>
            {/* ===== Group Header Row ===== */}
            <tr style={{ backgroundColor: "#ddd", fontWeight: "600", border: "1px solid #ccc" }}>
              <th colSpan="1" style={{ textAlign: "center", border: "1px solid #ccc", padding: "6px" }}>Menu Items</th>
              <th colSpan="1" style={{ textAlign: "center", border: "1px solid #ccc" }}>Value Story Type</th>
              <th colSpan={Object.keys(FIXED_ROLES).length} style={{ textAlign: "center" , border: "1px solid #ccc" }}>Roles</th>
            </tr>

            {/* ===== Actual column headers ===== */}
            <tr>
              <th style={{ textAlign: "center" , border: "1px solid #ccc" }}>Menu</th>
              <th ></th>
              {Object.entries(FIXED_ROLES).map(([roleId, roleName]) => (
                <th
                  key={roleId}
                  style={{
                    width: "130px",
                    textAlign: "center",
                    border: "1px solid #ccc",
                    padding: "6px",
                    whiteSpace: "normal",
                    lineHeight: "1.2em"
                  }}
                >
                  {roleName}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {this.state.configData.map((group, gIndex) => (
              <React.Fragment key={group.group}>
                <tr>
                  <td colSpan={Object.keys(FIXED_ROLES).length + 2} style={{ background: "#eee" }}>
                    <strong>{group.group}</strong>
                  </td>
                </tr>

                {group.items.map((item, iIndex) => (
                  <tr key={item.value}>
                    <td>{item.label}</td>

                    {/* Single Value Story Type column */}
                    <td
                      style={{
                        // backgroundColor: "#f1f1f1",
                        color: "#333",
                        fontWeight: "500",
                        whiteSpace: "nowrap",
                        padding: "6px 10px"
                      }}
                    >
                      {["Sales", "EnablementExecution"].map((vType, idx) => (
                        <span
                          key={vType}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            marginRight: idx === 0 ? "18px" : "0" // spacing only before second
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={item.valueStoryTypes.includes(vType)}
                            onChange={() => this.toggleValueStory(gIndex, iIndex, vType)}
                            style={{ marginRight: "6px" }}
                          />
                          {vType}
                        </span>
                      ))}
                    </td>

                    {/* Role Checkboxes */}
                    {Object.entries(FIXED_ROLES).map(([roleId, roleName]) => (
                      <td key={roleId} style={{ width: "110px", textAlign: "center" }}>
                        <input
                          type="checkbox"
                          checked={
                            this.state.solutionScope.toLowerCase() === "scc"
                              ? (item.visibleMatrix[roleName] && item.visibleMatrix[roleName].scc)
                              : this.state.solutionScope.toLowerCase() === "nonscc"
                                ? (item.visibleMatrix[roleName] && item.visibleMatrix[roleName].nonSCC)
                                : (item.visibleMatrix[roleName] && item.visibleMatrix[roleName].scc && item.visibleMatrix[roleName].nonSCC)
                          }
                          onChange={() => this.toggleRoleAccess(gIndex, iIndex, roleName)}
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>

        </table>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      user: state.default,
  }
}

export default connect(mapStateToProps, { fetchSpendDownloadMenuConfig, saveSpendDownloadMenuConfig })(AdminSpendDownloadMenu);
